<template>
	<div v-if="shouldRender">
		<div v-if="good_detail">
			<div v-if="page_type==1" class="co">
				<!-- <naviBack title="创建预约单" type="nav1" background="#F6F7F9" /> -->
				<div class="co_item_1">
					<div class="co_item_1_1">
						<div class="co_item_1_1_1">{{good_detail.goods_name}}</div>
						<div class="co_item_1_1_2">{{date_obj.date_pio}} {{time}}</div>
					</div>
					<div class="co_item_1_2">
						<div class="co_item_1_2_item">
							预约人
							<div>{{user_info.name}}</div>
						</div>
						<div class="co_item_1_2_item">
							手机号
							<div> {{user_info.phone}}</div>
						</div>
					</div>
				</div>
				<div class="co_item_2">
					<div @click="addGuest()" class="co_item_2_add">
						添加同行人
						<img src="../resource/add_F77F28.png" alt="" />
					</div>
					<div v-if="guest.length>0">
						<div v-for="(item_gu,index_gu) in guest" class="co_item_2_input">
							<input v-model="guest[index_gu]" type="text" placeholder="请输入姓名" />
							<div @click="deleteGuest(index_gu)"></div>
						</div>
					</div>
				</div>
				<div class="co_item_3">
					<div class="co_item_3_1 white_space font_weight">场馆信息</div>
					<div class="co_item_3_2 white_space">{{good_detail.venue_info.venue_name}}</div>
					<div @click="openMap()" class="co_item_3_3">
						<div class="co_item_3_3_address white_space">{{good_detail.venue_info.address}}</div>
						<!-- <div class="white_space2">　2.3km</div> -->
					</div>
				</div>
				<div class="co_item_4">
					<div class="co_item_4_1">
						<div class="co_item_4_1_title font_weight">价格明细</div>
						<div class="co_item_4_1_price">
							单价
							<div>¥{{good_detail.price}}</div>
						</div>
						<div class="co_item_4_1_price">
							数量
							<div>{{(guest.length+1)}}</div>
						</div>
						<div class="co_item_4_1_price">
							<div></div>
							<div class="co_item_4_1_price_flex">合计：<div>¥{{total_price}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="co_submit">
					<div class="co_submit_price">
						<div class="co_submit_price_1">实付：</div>
						<div class="co_submit_price_2">¥</div>
						<div class="co_submit_price_3">{{total_price}}</div>

						<div @click="detail_show=true" class="co_submit_price_4">
							明细
							<img class="co_submit_price_4_1" src="../resource/down.png" alt="" />
						</div>
					</div>
					<div @click="submitOrder()" class="co_submit_btn">提交订单</div>
				</div>

				<van-popup v-model="detail_show" position="bottom" closeable style="border-radius: 8px 8px 0 0">
					<div>
						<div class="co_submit2">金额明细</div>
						<div class="co_submit3">
							门市价
							<div>¥{{good_detail.market_price}}</div>
						</div>
						<div class="co_submit4">
							折扣
							<div>{{good_detail.price_key=='v60_price'?'6折':'6.5折'}}</div>
						</div>
						<div class="co_submit4">
							服务费+税费
							<div>15%</div>
						</div>
						<div class="co_submit3">
							合计
							<div>¥{{total_price}}</div>
						</div>
						<div class="co_submit5"></div>
						<div class="co_submit" style="box-shadow: none;position: relative;">
							<div class="co_submit_price">
								<div class="co_submit_price_1">实付：</div>
								<div class="co_submit_price_2">¥</div>
								<div class="co_submit_price_3">{{total_price}}</div>
								<div @click="detail_show=true" class="co_submit_price_4">
									明细
									<img class="co_submit_price_4_1" src="../resource/down.png" alt="" />
								</div>
							</div>
							<div @click="submitOrder()" class="co_submit_btn">提交订单</div>
						</div>
					</div>
				</van-popup>


			</div>
			<div v-if="page_type==2" class="cos">
				<naviBack title="" type="nav1" background="#FFFFFF" />

				<div class="co_success">
					<img class="co_success_icon" src="../resource/pay_success.png" alt="" />
					<div class="co_success_title">已收到预约，待平台确认</div>
					<div class="co_success_block">
						<!-- <div class="co_success_block_title font_weight">预约信息</div> -->
						<div class="co_success_block_stitle">预约课程：{{good_detail.goods_name}}</div>
						<div class="co_success_block_stitle">到店时间：{{date_obj.date_pio}} {{time}}</div>
						<div class="co_success_block_stitle">预约门店：{{good_detail.venue_info.venue_name}}</div>
					</div>
					<div class="co_success_btn">预约记录</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
	import naviBack from '../components/navi_back.vue';
	import {
		datePrintStr
	} from "../lib/utils.js"
	export default {
		components: {
			naviBack
		},
		data() {
			return {
				shouldRender: true,
				date: '',
				date_obj: null,
				time: '',
				goods_id: '',
				good_detail: null,

				total_price: 0, //总价

				user_info: null,

				page_type: 1, //1下单  2下单成功

				guest: [], //嘉宾列表
				max_guest_num: 1, //最大可约人数

				detail_show: false,
			}
		},
		watch: {
			$route() {
				// 路由变化时更新渲染状态
				this.shouldRender = false
				this.$nextTick(() => {
					this.shouldRender = true
				})
			}
		},
		mounted() {
			// location.reload()
			this.$loading('');
			this.$loading.close();
			this.$loading('正在加载中...');
			// console.log(this.$route.params);
			this.date = this.$route.params.date
			this.date_obj = datePrintStr(this.$route.params.date)
			this.time = this.$route.params.time
			this.goods_id = this.$route.params.goods_id
			this.getDetail()
			this.getUserInfo()
		},
		methods: {
			getDetail() {
				console.log(this.date_obj);
				var $this = this
				var param = {
					goodsId: this.goods_id
				}
				var qs = require('qs');
				let url = this.api.userApi.index_getGoodsInfo
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						// console.log(res)

						$this.good_detail = res.data
						$this.$loading.close();
						$this.computePrice()

						// if(res.data.class_id==1101){
						// 	document.title='五星酒店游泳健身'
						// }else if(res.data.class_id==1901){
						// 	document.title='五星酒店SPA'
						// }else if(res.data.class_id==1702){
						// 	document.title='连锁健身房'
						// }
						// $this.loadStock()
					}).catch((error) => {
						console.warn(error)
						$this.$loading.close();
						$this.$toast(error.msg ? error.msg : error.message);
					})
			},
			getUserInfo() {
				var $this = this
				var param = {}
				var qs = require('qs');
				let url = this.api.userApi.index_getUserInfo
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						// console.log(res)
						$this.user_info = res.data
					}).catch((error) => {
						console.warn(error)
						$this.$toast(error.msg ? error.msg : error.message);
					})
			},
			// 新增嘉宾
			addGuest() {
				if (this.guest.length == this.max_guest_num) {
					this.$toast('最大可携带' + this.max_guest_num + '位同行人');
					return
				}
				this.guest.push('');
				this.computePrice()
			},
			// 删除嘉宾
			deleteGuest(e) {
				this.guest.splice(e, 1);
				this.computePrice()
			},
			// 计算价格
			computePrice() {
				var single_price = parseFloat(this.good_detail.price, 10) //单价
				var num = this.guest.length + 1 //数量
				var total_price = single_price * num
				this.total_price = total_price
			},
			// 打开地图
			openMap() {
				console.log(this.good_detail.venue_info);
				return
				window.location.href =
					`https://uri.amap.com/marker?position=${this.good_detail.venue_info.lon},${this.good_detail.venue_info.lat}&name=${this.good_detail.venue_info.address}`;
			},
			// 下单
			submitOrder() {
				var $this = this


				var channel = 'ysf_app'
				var link = ''
				var agent = navigator.userAgent.toLowerCase();
				var isInsideWallet = ((new RegExp(/(com.unionpay.chsp)/).test(agent)) || (new RegExp(
					/(com.unionpay.mobilepay)/).test(agent)));
				if (isInsideWallet) {
					channel = 'ysf_app'
				} else if (agent.match(/MicroMessenger/i) == "micromessenger") {
					channel = 'ysf_xcx'
				}
				if (this.guest.length > 0 && this.guest.join().length == 0) {
					this.$toast('请完善同行人信息！');
					return
				}
				var params = {
					goodsId: this.goods_id,
					bookDay: this.date,
					bookTime: this.time,
					channel: channel,
					guest: this.guest.join(),
				}
				this.$loading('正在加载中...');
				var $this = this
				var qs = require('qs');
				var url = this.api.userApi.index_createOrder
				this.axios.post(url, qs.stringify(params))
					.then((res) => {
						console.log(res);
						// $this.page_type=2
						// $this.$loading.close();
						window.location.href = res.data.url
					}).catch((error) => {
						$this.$loading.close();
						$this.$toast(error.msg ? error.msg : error.message);
					})
			},
		}
	}
</script>
<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;

	.co {
		width: 100%;
		min-height: 100vh;
		background-color: #F6F7F9;
		padding: 10*@vm_base 20*@vm_base 20*@vm_base 20*@vm_base;
		// padding-bottom: calc(constant(safe-area-inset-bottom) / 2+ 30*@vm_base);
		// padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 30*@vm_base);
	}

	.co_item_1 {
		width: 100%;
		background: #FFFFFF;
		border-radius: 8*@vm_base;
		padding: 0 30*@vm_base;

		.co_item_1_1 {
			width: 100%;
			padding: 40*@vm_base 0 30*@vm_base 0;
			border-bottom: 1*@vm_base dashed #D9D9D9;
			color: #333333;

			.co_item_1_1_1 {
				font-size: 36*@vm_base;

			}

			.co_item_1_1_2 {
				padding-top: 20*@vm_base;
				font-size: 36*@vm_base;
			}
		}

		.co_item_1_2 {
			width: 100%;
			padding: 30*@vm_base 0;

			.co_item_1_2_item {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 10*@vm_base 0;
				font-size: 30*@vm_base;
				color: #666666;

				div {
					font-size: 30*@vm_base;
					color: #333333;
				}
			}
		}
	}

	.co_item_2 {
		width: 100%;
		background: #FFFFFF;
		border-radius: 8*@vm_base;
		margin-top: 20*@vm_base;

		.co_item_2_add {
			width: 100%;
			height: 90*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 28*@vm_base;
			color: #333333;

			img {
				width: 36*@vm_base;
				margin-left: 10*@vm_base;
			}
		}

		.co_item_2_input {
			width: 100%;
			border-top: 1*@vm_base solid #F0F0F0;
			display: flex;
			justify-content: space-between;
			align-items: center;

			input {
				width: calc(100% - 80*@vm_base);
				height: 80*@vm_base;
				border: none;
				outline: none;
				padding-left: 20*@vm_base;
				font-size: 28*@vm_base;
			}

			div {
				width: 80*@vm_base;
				height: 80*@vm_base;
				background-image: url(../resource/delete.png);
				background-size: 50%;
				background-position: center;
				background-repeat: no-repeat;
			}
		}
	}

	.co_item_3 {
		width: 100%;
		background: #FFFFFF;
		border-radius: 8*@vm_base;
		margin-top: 20*@vm_base;
		padding: 30*@vm_base;

		.co_item_3_1 {
			font-size: 30*@vm_base;
			color: #333333;
		}

		.co_item_3_2 {
			width: 100%;
			font-size: 30*@vm_base;
			color: #333;
			margin-top: 30*@vm_base;
		}

		.co_item_3_3 {
			width: fit-content;
			max-width: 100%;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			margin-top: 10*@vm_base;
			font-size: 24*@vm_base;
			color: #999999;
			// background-image: url(../resource/fly.png);
			// background-size: auto 100%;
			// background-repeat: no-repeat;
			// background-position: right center;
			padding: 4*@vm_base 0;

			.co_item_3_3_address {
				max-width: 100%;
				width: fit-content;
			}
		}
	}

	.co_item_4 {
		width: 100%;
		background: #FFFFFF;
		border-radius: 8*@vm_base;
		margin-top: 20*@vm_base;

		.co_item_4_1 {
			width: 100%;
			padding: 30*@vm_base 20*@vm_base;

			.co_item_4_1_title {
				font-size: 30*@vm_base;
				color: #333333;
			}

			.co_item_4_1_price {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 28*@vm_base;
				color: #666666;
				margin-top: 30*@vm_base;

				.co_item_4_1_price_flex {
					display: flex;
					justify-content: center;
					align-items: center;

					div {
						color: #F77F28;
					}
				}
			}
		}
	}

	.co_submit {
		width: 100%;
		position: fixed;
		left: 0;
		bottom: 0;
		z-index: 99;
		height: calc(constant(safe-area-inset-bottom) / 2 + 130*@vm_base);
		height: calc(env(safe-area-inset-bottom) / 2 + 130*@vm_base);
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2);
		background: #FFFFFF;
		border-radius: 16*@vm_base 16*@vm_base 0 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 20*@vm_base 0 40*@vm_base;
		box-shadow: -4px -4px 6px rgba(243, 207, 166, 0.5);

		.co_submit_price {
			display: flex;
			justify-content: center;
			align-items: flex-end;
			font-size: 24*@vm_base;

			.co_submit_price_1 {
				color: #333333;
				line-height: 1.3;
			}

			.co_submit_price_2 {
				color: #F77F28;
				line-height: 1.3;
			}

			.co_submit_price_3 {
				font-size: 54*@vm_base;
				color: #F77F28;
				margin-left: 9*@vm_base;
			}

			.co_submit_price_4 {
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 24*@vm_base;
				color: #F77F28;
				padding-left: 30*@vm_base;
				line-height: 1.3;

				img {
					width: 20*@vm_base;
					margin-left: 8*@vm_base;
				}

				.co_submit_price_4_1 {
					transform: rotateZ(-90deg);
				}
			}
		}

		.co_submit_btn {
			width: 250*@vm_base;
			height: 80*@vm_base;
			background: linear-gradient(319deg, #FB8027 0%, #FFA663 100%);
			border-radius: 40*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 32*@vm_base;
			color: #FFFFFF;
		}
	}
	.co_submit2{
		width: 100%;
		padding: 50*@vm_base;
		text-align: center;
		font-weight: 600;
		font-size: 36*@vm_base;
		color: #333333;
	}
	.co_submit3{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 32*@vm_base;
		font-weight: 600;
		font-size: 32*@vm_base;
		color: #333333;
		padding: 0 40*@vm_base;
		div{
			color: #F77F28;
		}
	}
	.co_submit4{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 32*@vm_base;
		font-size: 28*@vm_base;
		color: #333333;
		padding: 0 40*@vm_base;
	}
	.co_submit5{
		height: 40*@vm_base;
	}

	.co_success {
		width: 100%;
		padding: 120*@vm_base 125*@vm_base 40*@vm_base 125*@vm_base;
		text-align: center;

		.co_success_icon {
			width: 160*@vm_base;
			margin: 0 auto;
		}

		.co_success_title {
			width: 100%;
			text-align: center;
			font-size: 36*@vm_base;
			color: #F77F28;
			margin-top: 100*@vm_base;
		}

		.co_success_block {
			width: 100%;
			color: #333333;
			text-align: left;
			margin-top: 48*@vm_base;
			padding: 0 34*@vm_base;


			.co_success_block_stitle {
				font-size: 30*@vm_base;
				margin-top: 24*@vm_base;
				color: #666666;
			}
		}

		.co_success_btn {
			width: 100%;
			height: 80*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 32*@vm_base;
			border-radius: 40*@vm_base;
			background: linear-gradient(319deg, #FB8027 0%, #FFA663 100%);
			color: #fff;
			margin: 0 auto;
			margin-top: 100*@vm_base;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/create_order.vue